import { isSchoolAdmin, isProgramAdmin, TEACHER_ROLE } from 'constants/user';

export const hasMajorRole = (myRole, userRole) => {
  if (isSchoolAdmin(myRole) && isProgramAdmin(userRole)) return false;
  if (myRole === TEACHER_ROLE && (isSchoolAdmin(userRole) || isProgramAdmin(userRole))) return false;
  return true;
};
